// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "../../components/layout/LoadingComponent";
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
const ContactSupport = lazy(() => import ('../../containers/support/ContactSupport'));

function Page() {
  return (
    <Suspense fallback={<LoadingComponent />}>
        <OpenRoute><ContactSupport /></OpenRoute>
    </Suspense>
  );
}

export {Page};